import { render, staticRenderFns } from "./JerseyField.vue?vue&type=template&id=722b48f4&scoped=true&"
import script from "./JerseyField.vue?vue&type=script&lang=ts&"
export * from "./JerseyField.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyField.vue?vue&type=style&index=0&id=722b48f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b48f4",
  null
  
)

export default component.exports